import React from 'react';

type Props = {
  width: number | string;
  height: number | string;
};

const DiscussionSpeechBubble: React.FC<Props> = ({
  width = '100%',
  height = '100%',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 16"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="currentColor" fillRule="nonzero">
          <path
            d="M6 4.5c-1.094 0-1.982.84-2 1.883V14.13c0 1.047.878 1.897 1.967 1.914h7.343l3.803 3.252c.153.13.35.203.554.203.452 0 .82-.347.833-.78v-2.735c.853-.21 1.485-.945 1.5-1.823V6.414c0-1.046-.878-1.897-1.967-1.914H6zm11.5 13.841l-3.582-3.178h-.002l-.089-.08H6c-.544 0-.986-.415-1-.932V6.418c0-.52.434-.943.975-.956H18c.544 0 .986.415 1 .932v7.733c0 .52-.434.943-.975.956H17.5v3.258zm-1.298-6.846c.43 0 .777.19.777.424 0 .233-.348.423-.777.423H7.755c-.429 0-.776-.19-.776-.423 0-.234.347-.424.776-.424h8.447zm0-1.693c.43 0 .777.19.777.423 0 .234-.348.423-.777.423H7.755c-.429 0-.776-.19-.776-.423 0-.234.347-.423.776-.423h8.447zm0-1.694c.43 0 .777.19.777.423 0 .234-.348.424-.777.424H7.755c-.429 0-.776-.19-.776-.424 0-.234.347-.423.776-.423h8.447z"
            transform="translate(-594 -1218) translate(563 344) translate(0 639) translate(16 222) translate(-1 -1) translate(.965) translate(12 10)"
          />
        </g>
      </g>
    </svg>
  );
};

export default DiscussionSpeechBubble;
